import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { getURLbyEndPointV2 } from "../../../../store/api";
import { formatDateTime } from "../../../../components/basic/SimpleFunctions";

const CountryDetails = ({ country, setActiveGlobalTab }) => {
    const [lawFirmsWithSlots, setLawFirmsWithSlots] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchLawFirmsWithSlots = async () => {
            try {
                const response = await axios.get(
                    getURLbyEndPointV2("getLawFirmsWithSlotsByCountry") + country
                );
                setLawFirmsWithSlots(response.data.data);
            } catch (error) {
                console.error("Error fetching law firms with slots:", error);
            }
        };

        fetchLawFirmsWithSlots();
    }, [country]);

    const handleSlotSelection = (slotId) => {
        setSelectedSlots(prevSelectedSlots =>
            prevSelectedSlots.includes(slotId)
                ? prevSelectedSlots.filter(id => id !== slotId)
                : [...prevSelectedSlots, slotId]
        );
    };

    const handleBookSlots = async () => {
        try {
            const response = await axios.post(getURLbyEndPointV2("bookSlots"), {
                slotIds: selectedSlots,
            });
            console.log("Slots booked successfully:", response.data);
            setShowModal(false);
        } catch (error) {
            console.error("Error booking slots:", error);
        }
    };

    return (
        <div>
            <h3 className="text-xl font-bold mb-4">collaborators in {country}</h3>
            {lawFirmsWithSlots.map((lawFirm, index) => (
                <Card key={index} className="mb-4">
                    <Card.Body>
                        <Card.Title>{lawFirm.lawFirm}</Card.Title>
                        <div className="mt-3">
                            <h5>Industries:</h5>
                            <p>{lawFirm.industries.join(", ")}</p>
                            <h5>Expertise:</h5>
                            <ul>
                                {Object.entries(lawFirm.expertise).map(([key, values]) => (
                                    <li key={key}>
                                        <strong>{key}:</strong> {values.join(", ")}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div
                            className="d-grid gap-2"
                            style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
                        >
                            {lawFirm.slots.map((slot, slotIndex) => (
                                <Card
                                    key={slotIndex}
                                    className={`cursor-pointer ${selectedSlots.includes(slot._id)
                                            ? "bg-primary text-white"
                                            : "bg-gray-200"
                                        }`}
                                    onClick={() => handleSlotSelection(slot._id)}
                                >
                                    <Card.Body className="p-2 text-center">
                                        {slot.startTime} - {slot.endTime} <br /> {formatDateTime(slot.date)}
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </Card.Body>
                </Card>
            ))}
            {selectedSlots.length > 0 && (
                <Button onClick={() => setShowModal(true)}>Book Selected Slots</Button>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Slot Booking</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to book the selected slots?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleBookSlots}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CountryDetails;